export enum ForgotPasswordFormFields {
  email = 'email',
}

export type ForgotPasswordFormValues = {
  [ForgotPasswordFormFields.email]: string;
};
